export enum UserMenuOption {
  Logout = 'Se deconnecter',
}
